import script from "./Installadd.vue?vue&type=script&setup=true&lang=js"
export * from "./Installadd.vue?vue&type=script&setup=true&lang=js"

import "./Installadd.vue?vue&type=style&index=0&id=f5e872ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5e872ec"]])

export default __exports__